import { Node } from 'reactflow';
import { BdaService } from "./BdaService";
import { BdaApplication } from './BdaApplication';
import { NodeType } from './Designer';

export interface DashboardStatistics {
  createdDatasets: number;
  createdModels: number;
  createdServices: number;
  bdaApplicationsCompleted: number;
  bdaApplicationsFailed: number;
  bdaApplicationsRunning: number;
  myBdaApplicationsPrivate: number;
  myBdaApplicationsPublic: number;
  myBdaApplicationsTeam: number;
  myServicesPrivate: number;
  myServicesPublic: number;
  myServicesTeam: number;
  numBdaAppCreateFromTo: number;
  numBdaAppRunningFromTo: number;
  bdaApplicationsByMonth: Record<string, number>;
}

// TODO improve type
export type UsedItem<T> = Partial<Node<T, NodeType>> & Partial<T> & {
  id?: number;
  isNodePort?: boolean;
  isOutput?: boolean;
  service?: Exclude<UsedItem<BdaService>, 'service'>;
  inputs?: any[];
  outputs?: any[];
  ref?: string;
  cascade?: boolean;
};

export interface KrakendCollection<T> {
  collection: Array<T>;
}

interface PageMetadata {
  currentPage: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface PagedResults<T> {
  content: Array<T>;
  pageMetadata: PageMetadata;
}

export enum ExecutionStatus {
  READY = "READY",
  STARTING = "STARTING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
  PARTIAL = "PARTIAL",
  STOPPING = "STOPPING",
  STOPPED = "STOPPED",
}

export enum AccessLevel {
  PRIVATE = 'PRIVATE',
  TEAM = 'TEAM',
  PUBLIC = 'PUBLIC'
}

export interface Option {
  label: string;
  value: string | number;
}

export class ExportOptions {
  id: number;
  kafka?: boolean;
  rar: boolean;
  args: any;
  bda?: BdaApplication;

  constructor(id: any) {
    this.id = id ? typeof id === 'string' ? +id : id : undefined;
    this.kafka = false;
    this.rar = false;
    this.args = null;
  }
}

export interface AssetFile {
  accessLevel: string;
  bdaId: string;
  content: string;
  created: string;
  description: null;
  executionId: string;
  executorId: string;
  executorName: string;
  executorOrgId: string;
  executorOrgName: string;
  extension: string;
  filename: string;
  key: string;
  localPath: string;
  messageType: "html" | "picture" | "log" | "file";
  valueType: 'int' | 'float' | 'boolean' | 'json';
  modified: string;
  name: string;
  organizationId: string;
  ownerId: string;
  path: string;
  serviceId: string;
  show: boolean;
  title: string;
  uuid: string;
  var: any;
  value?: string | number;
}

export interface AssetFileDetails {
  type: string;
  path: string;
  returnRawFile?: boolean;
}